import styled from 'styled-components';

import { MessageWarning } from '../ui/Message';

export default styled.div``;

export const Error = styled(MessageWarning)`
  margin-bottom: 1rem;
`;
